import React from 'react';
import Breadcrumbs from 'react-breadcrumbs';
import Toaster from 'toastr';
import {connect} from 'react-redux';
import {Permissioned} from 'react-permissions';
import Divider from '../../common/divider';
import PageTitle from '../../common/pageTitle';
import Util from '../../../util/util';
import Permissions from '../../../configurations/permissions';
import Messages from '../../../configurations/messages';
import Constants from '../../../configurations/constants';
import ArbiterApi from '../../../api/ArbiterApi';
import DisputeRegionsTable from './disputeRegionsTable';
import DisputeRegionsModal from './disputeRegionsModal';




class DisputeRegionsPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            disputeRegions: [],
            selectedDisputeRegion: null,
            totalCount: 0,
            loading: false,
            pages: 0,
            openModalFlag: false,
            createFlag: false,
            pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
            pageNum: 0, //Zero based index
        };
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onNewButtonClick = this.onNewButtonClick.bind(this);
    }

    componentDidMount() {
        //Load data on mount
        this.reloadRegions();
    }

    onNewButtonClick(evt) {
       
        this.setState({ openModalFlag: true, createFlag: true });
    }

    render() {
        
        return (

            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                    <Breadcrumbs routes={this.props.routes}
                        params={this.props.params} />
                </div>
                <PageTitle title="Dispute Regions" />
                <Divider />
                <div className="mini-filter align-right" >
                    <button onClick={this.onNewButtonClick} className="btn btn-primary" >+ New Dispute Region</button>                
                </div>
                <DisputeRegionsTable
                    onRowClick={this.onRowClick}
                    loading={this.state.loading}
                    onTableChange={this.onTableChange}
                    page={this.state.pageNum}
                    pages={this.state.pages}
                    defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                    disputeRegions={this.state.disputeRegions}
                />
                {this.state.openModalFlag &&
                    <DisputeRegionsModal
                        isNew={this.state.createFlag}
                        isOpen={this.state.openModalFlag}
                        onRequestClose={this.handleCloseModal}
                        disputeRegion={this.state.selectedDisputeRegion}
                    />
                }
            </div>
        )
    }


    onTableChange(state, instance) {
        let pageSize = instance.state.pageSize;
        let pageNum = (instance.state.page); //table page  - Zero based index
        this.setState({ pageSize: pageSize, pageNum: pageNum });
        if (this.state.filterParams) {
            let params = Util.clone(this.state.filterParams);
            params.pageSize = pageSize;
            params.pageNum = pageNum + 1;

            this.loadRegions(params);
        }

    }

    loadRegions(params, resetPageNumber) {
        //Reset states 
        let stateUpdate = { loading: true, disputesBatches: [] };
        if (resetPageNumber) {
            stateUpdate.pageNum = 0;
            params.pageNum = 1;
        }
        this.setState(stateUpdate);
        params.pageSize = params.pageSize || this.state.pageSize;
        params.pageNum = params.pageNum || (this.state.pageNum + 1);

        ArbiterApi.getDisputeRegions(params)
            .then((response) => {
                let data = response.data.content;
                let totalCount = response.data.count;
                let pages = totalCount ? Math.ceil(totalCount / (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)) : 0;
                if (data.length === 0)
                    Toaster.warning("No records found.", "Dispute Regions")
                this.setState({ disputeRegions: data, loading: false, filterParams: params, totalCount: totalCount, pages: pages });
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_DISPUTE_REGION} - ${error.data ? error.data.description : error.statusText}`, `${error.status}`);
                this.setState({ loading: false });
            });
    }

    onRowClick(index) {
        this.setState({ selectedDisputeRegion: this.state.disputeRegions[index], openModalFlag: true, createFlag: false });
    }
    handleCloseModal(event, reloadDataFlag) {
        this.setState({ selectedDisputeRegion: null, openModalFlag: false, createFlag: false });
        if (reloadDataFlag) {
            this.reloadRegions();
        }
    }

    reloadRegions() {
        this.setState({disputeRegions : []});
        this.loadRegions({ pageSize: this.state.pageSize });
    }

}


export default connect(Util.defaultMapStateToProps)(Permissioned(DisputeRegionsPage, [Permissions.VIEW_DISPUTE_REGION]));;


// WEBPACK FOOTER //
// ./src/components/admin/disputeRegions/disputeRegionsPage.js